import { render, staticRenderFns } from "./DealCard.vue?vue&type=template&id=de8f9de2&scoped=true&"
import script from "./DealCard.vue?vue&type=script&lang=js&"
export * from "./DealCard.vue?vue&type=script&lang=js&"
import style0 from "./DealCard.vue?vue&type=style&index=0&id=de8f9de2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8f9de2",
  null
  
)

export default component.exports